export default class AttachableConstants {
    public static DISTANCE = 1.5;
    public static HEIGHT = 1;
    // public static HEIGHT = 0.7;
    public static MIN_ZOOM = -1;
    public static MAX_ZOOM = 3;
    public static DEFAULT_ZOOM = 0;
}
